// Using double quotes in this file to prevent issues with apostrophes (')
export default {
  header: {
    ai: {
      title: 'HP Nioに質問する',
      close: 'Nioとのチャットを閉じる',
      open: 'Nioとのチャットを開く',
      morningGreeting: "{0}さん、おはようございます。",
      afternoonGreeting: "{0}さん、こんにちは。",
      eveningGreeting: "{0} さん、こんばんは。",
      morningGreetingGeneric: "おはようございます。",
      afternoonGreetingGeneric: "こんにちは。",
      eveningGreetingGeneric: "こんばんは。",
      opening: "私はNioです。何かお手伝いできることはありますか?",
      openingPrivacy: "私はNioです。",
      pbIntro1: "デバイスの生産性についてお尋ねください。",
      alertBeta: "Nioはまだ初期ベータ版です。現在、回答はPrint Beatとナレッジゾーンに限定されています。",
      alertDefault: "現在、回答はPrint Beatとナレッジゾーンに限定されています。",
      intro2:  "興味深いと思われる質問をいくつかご紹介します:",
      kzIntro1: "懸念事項についてお尋ねください。ナレッジゾーンの情報に基づいてお答えします。",
      pbSample1: "昨日のサイトの生産性はどれくらいでしたか?",
      pbSample2: "生産性を向上させるにはどうすればいいでしょうか?",
      pbSample3: "どのプレスが他のプレスよりも優れていますか?",
      pbSample4: "最も時間のロスが大きかったのはどの用紙ですか?",
      pbSample5: "先週、私はどの問題に最も時間を浪費したでしょうか?",
      kzSample1: "品質を維持し、コストを削減しながら、用紙の無駄を減らすにはどうすればよいでしょうか?",
      kzSample2: "色の一貫性のある効率的なワインラベル印刷に最適なHP Indigo印刷機はどれですか?",
      kzSample3: "生産性を高めるためにサプライ品の使用を最適化するにはどうすればよいでしょうか?",
      kzSample4: "印刷において考慮すべき主要な持続可能性の要素は何ですか?",
      kzSample5: "HP Indigo 6000 Pressと20K Press間の色の一貫性を確保するにはどうすればよいですか?",
      feedbackTitle: "スコアの理由",
      feedbackPlaceholder: "どのようなことが起きたか詳しく説明していただけますか?",
      fbPositive1: "データが正確",
      fbPositive2: "非常によくできた回答",
      fbPositive3: "非常に詳細",
      fbPositive4: "回答が適切だった",
      fbOther: "その他",
      fbNegative1: "情報またはデータが不正確",
      fbNegative2: "私の質問に対する回答ではなかった",
      fbNegative3: "回答が分かりにくかった",
      fbNegative4: "回答が適切でなかった",
      feedbackSubmittedTitle: "フィードバックをありがとうございました。",
      feedbackSubmittedDescription_Positive: "お役に立ててうれしく思います。使い勝手を改善していく上で、フィードバックは大きな力となります。",
      feedbackSubmittedDescription_Negative: "ご不便をおかけして申し訳ありません。内容を確認の上、問題の修正を行ってまいります。改善に役立てますので、エラーに関するその他の情報や関連するフィードバックがある場合はお知らせください。",
      ask_Placeholder: "何を知りたいですか?",
      answerCopiedToClipboard: "回答がクリップボードにコピーされました",
      feedbackSubmitted: "フィードバックが送信されました",
      feedbackCleared: "フィードバックが削除されました",
      newConversation: "新しいチャット",
      chatHistory: "チャット履歴",
      submitQuestion: "質問を送信",
      defaultStopMessage: "ユーザーによって応答が中止されました。",
      stopQuestion: "生成の停止",
      responseError: "申し訳ございません。こちら側で問題が発生したようです。後でやり直してください。問題が継続する場合は、サポートに連絡してください。",
      responseError400: "質問に予期しない文字が含まれているようです。続行するには、これらの文字を削除してください。",
      responseError429: "少々落ち着いてください。そんなにたくさんの質問には対応できません。",
      like: "良い",
      dislike: "悪い",
      copy: "クリップボードにコピー",
      retry: "再試行",
      contact: "お問い合わせ",
      contactSubject: "HP Nioの問題",
      contactQuestion: "質問: {0}",
      noConversations: "会話はありません",
      startConversation: "会話を開始すると、ここにチャット履歴が表示されます",
      today: "本日",
      yesterday: "昨日",
      lastWeek: "先週",
      older: "さらに前",
      chatDeletePolicy: "非アクティブなチャットは90日後に自動的に削除されます。",
      privacyNotice: "このチャットはAIが対応しています。回答が不完全または不正確である可能性がありますので、確認してください。",
      privacy1: "AIソリューションを利用しようとしています。チャットは閲覧され、当社のモデルのトレーニングに使用されることがあります。",
      privacy2: `If you prefer to receive support in another way, please visit {0}.`,
      acceptPrivacy: "HP Nioとチャットを始める",
      deleteConversationTitle: "チャットの削除",
      conversationName: "会話",
      deleteConversationConfirm: "これにより、<b>{0}</b>が削除されます。<br>この操作を元に戻すことはできません。",
      deleteConversationSuccess: "会話が削除されました",
      deleteConversationError: "会話を削除できませんでした",
      renameConversationTitle: "会話の名前を変更",
      renameConversationMessage: "会話名",
      renameConversationSuccess: "会話の名前が変更されました",
      renameConversationError: "会話の名前を変更できませんでした",
      deleteConversation: "削除",
      renameConversation: "名前の変更",
    },
    apps: {
      title: "メニュー",
      externalLinks: "外部",
      availableApps: "調べる",
      configure: "カスタマイズ",
      showApp: "表示",
      hideApp: "表示しない",
      setDefault: "デフォルトアプリケーションの設定",
      setShortcut: "固定する",
      removeShortcut: "固定を解除する",
      showAllApps: "すべてのアプリケーションを表示する",
      shortCutTooltip: "{0}に移動する",
      currentAccount: "現在の組織",
      goHome: "ホームに戻る",
      goAppHome: "アプリケーションの開始ページに移動",
      byProvider: "{0} 別",
      quickFilter: "アプリケーションの検索...",
      allApps: "すべてのアプリケーション",
      recentApps: "最近",
      externalApp: "PrintOS外のアプリケーション",
      modeSwitcher: "ダーク/ライトモード",
      goProducts: "その他のアプリを探す"
    },
    panels: {
      ai: "HP Nioに質問する",
      notifications: "個人用通知",
      help: "ヘルプとサポート",
      user: "ユーザー",
      close: "パネルを閉じる",
      moveLeft: "左に移動",
      moveRight: "右に移動",
      maximize: "最大化",
      restore: "復元",
    },
    user: {
      account: "組織",
      returnToHP: "HP Inc.に返却する",
      myOrganization: "マイ組織",
      myOrganizations: "マイ組織",
      myReports: "マイレポート",
      mySettings: "個人用設定",
      signOut: "サインアウト",
      signInExplanation: "通知とアプリケーションを表示するには、HP PrintOSにサインインしてください。",
      signIn: "サインイン",
      RCDA: "カスタマーのアクセス",
      orphanUser: "PrintOSユーザー",
      orphanContext: "組織がありません",
      deviceUser: "PrintOSデバイス",
      anonymous: "匿名ユーザー",
      name: "名前",
      email: "電子メール",
      address: "住所",
      editUser: "HPアカウントの編集",
      viewPrivacy: "プライバシーに関する声明の表示"
    },
    date: {
      fewSecondsAgo: "数秒前",
      minuteAgo: "1分前",
      minutesAgo: "{0} 分前",
      hourAgo: "1時間前",
      hoursAgo: "{0} 時間前",
      dayAgo: "1日前",
      daysAgo: "{0} 日前",
      monthAgo: "1か月前",
      monthsAgo: "{0} か月前",
      yearAgo: "1年前",
      yearsAgo: "{0} 年前",
    },
    help: {
      quickFilter: "検索",
      page: "ページ",
      app: "アプリケーション",
      newFeatures: "新機能",
      more: "すべて",
      contactHP: "HPに連絡する",
      noTopics: "一致するヘルプトピックはありません",
      about: "本サービスについて",
      terms: "サービス利用条件",
      readFile: "ドキュメント",
      stepByStepTutorial: "チュートリアル",
      goLink: "アプリケーションページ",
      viewVideo: "ビデオ",
      goToUrl: "リンク",
      other: "その他",
      faq: "よくある質問",
      new: "新しいトピック",
      whatsNew: "最新情報",
      technicalSupport: "PrintOSサポート",
      printOSFeedback: "PrintOSフィードバック",
      conversationsWithHP: "HPとの会話",
      youMayConsider: "ご検討ください...",
      myKzArticles: "マイナレッジゾーンの記事",
      kzServiceTopics: "{0}（{1}）",
      lkcArticles: "HP Latexナレッジセンターの記事",
    },
    notifications: {
      noNotifications: "通知はありません",
      viewAll: "すべて表示",
      dismiss: "解除",
      dismissAll: "すべて解除",
      subscriptions: "設定",
    },
    marketplace: {
      title: "マーケットプレイス",
      explore: "すべて検索",
      featured: "注目",
      slides: {
        default: {
          description: "プレミアムアプリケーション、拡張、およびコネクターを使用してPrintOSを強化"
        },
        oee: {
          title: "Print Beat OEE",
          description: "ほぼリアルタイムのデータをもとに状況を判断し、最適な稼動を実現します",
        },
      },
      partialProductivitySubscribePreEnforcement_Title: "8月4日より、Indigo Print Beat、ジョブ、OEE、Print Beatサービスにアクセスするには、<a href='https:/intercom.help/hp-printos/en/articles/11113950-hp-printos-productivity-power-pack' target='_blank'>生産性パワーパックのサブスクリプション</a>が必要になります。",
      partialProductivitySubscribePreEnforcement_Desc: "サブスクリプションが解除されたデバイスのデータは、8月より前まで抽出できます。",
      partialProductivitySubscribePostEnforcement_Title: "お使いのすべてのIndigoデバイスが生産性パワーパックにサブスクリプションされているわけではありません（{0}/{1}）",
      partialProductivitySubscribePostEnforcement_Desc: "サブスクリプションが解除されたデバイスでは、PrintOSのエクスペリエンス（Print Beat、ジョブ、OEE、ダッシュボードなど）が制限される場合があります",
      goToMarket_Action: "マーケットプレイスに移動",
      howToExtract_Action: "データを抽出する方法"
    },
    focus: {
      title: "Focus",
    },
    locales: {
      "de-DE": "ドイツ語",
      "en-GB": "英語（イギリス）",
      "en-US": "英語（米国）",
      "es-ES": "スペイン語",
      "fr-FR": "フランス語",
      "it-IT": "イタリア語",
      "ja-JP": "日本語",
      "ko-KO": "韓国語",
      "pt-PT": "ポルトガル語",
      "tr-TR": "トルコ語",
      "zh-HANS": "中国語（簡体字）",
      "ru-RU": "ロシア語",
      "部分的な翻訳": "部分的な翻訳",
    },
    modal: {
      ok: "OK",
      cancel: "キャンセル",
    },
    combo: {
      noItems: "一致するものがありません",
    },
    nps: {
      question: "{0}さん、PrintOSを同僚にどのくらい勧めたいと思いますか?",
      // In case we can't get user's display name
      questionNameless: "PrintOSを同僚にどのくらい勧めたいと思いますか?",
      notLikely: "全くそう思わない",
      likely: "ぜひ勧めたい",
      send: "フィードバックの送信",
      response: {
        detractor: "{0}さん、PrintOSに改良すべき点がありましたら、ぜひご提案ください。いただいたご意見はすべて拝見いたします。",
        detractorNameless: "PrintOSに改良すべき点がありましたら、ぜひご提案ください。いただいたご意見はすべて拝見いたします。",
        passive: "{0}さん、PrintOSを使いやすくするための改良点を教えてください。いただいたご意見はすべて拝見いたします。",
        passiveNameless: "PrintOSを使いやすくするための改良点を教えてください。いただいたご意見はすべて拝見いたします。",
        promoter: "{0}さん、PrintOSにご満足いただきまして、誠にありがとうございます。ぜひ、その理由をお聞かせください。いただいたご意見はすべて拝見いたします。",
        promoterNameless: "PrintOSにご満足いただきまして、誠にありがとうございます。ぜひ、その理由をお聞かせください。いただいたご意見はすべて拝見いたします。",
      },
      introMorning: "{0}さん、おはようございます。PrintOSのカスタマーサクセスマネージャー、Jonです。 ",
      introMorningNameless: "{0}さん、おはようございます。PrintOSのカスタマーサクセスマネージャー、Jonです。 ",
      introAfternoon: "{0}さん、こんにちは。PrintOSのカスタマーサクセスマネージャー、Jonです。 ",
      introAfternoonNameless: "{0}さん、こんにちは。PrintOSのカスタマーサクセスマネージャー、Jonです。 ",
      introEvening: "{0}さん、こんばんは。PrintOSのカスタマーサクセスマネージャー、Jonです。 ",
      introEveningNameless: "{0}さん、こんばんは。PrintOSのカスタマーサクセスマネージャー、Jonです。 ",
      intro2: "次の質問に答えることで、ぜひ、PrintOSの使い勝手に関するご意見をお寄せください。",
      intro3: "PrintOSを同僚にどのくらい勧めたいと思いますか?",
      detractorResponse: "{0}さん、ご回答ありがとうございます。フィードバックは、好意的なものであれ、批判的なものであれ、どちらも非常に貴重な情報です。",
      detractorResponseNameless: "ご回答ありがとうございます。フィードバックは、好意的なものであれ、批判的なものであれ、どちらも非常に貴重な情報です。",
      promoterResponse: "{0}さん、ありがとうございます。PrintOSのファンであるとは、うれしい限りです。使い勝手を可能な限り良くする上で、フィードバックは大きな力となります。",
      promoterResponseNameless: "ありがとうございます。PrintOSのファンであるとは、うれしい限りです。使い勝手を可能な限り良くする上で、フィードバックは大きな力となります。",
      response2: "アプリケーションを選択し、PrintOSをさらに良くするにはどうすればよいか、ご意見をお聞かせください。",
      response3: "カスタマーサクセスチームがすべてのコメントに目を通します。フィードバックの内容についてさらに確認するため、問い合わせを行うことがありますのでご了承ください。",
      feedbackPlaceholder: "次の手段でPrintOSを改善できます...",
      application: "アプリケーション",
      noApplication: "PrintOS - 全般的なフィードバック"
    },
    subscription: {
      title: "通知",
      subscribe: "今すぐご購入ください",
      noticeSingular: "{0} サブスクリプションはあと {1} 日で期限が切れます。",
      notice: "{0} サブスクリプションはあと {1} 日で期限が切れます。",
    },
    promotion: {
      label: "キャンペーン",
      title: "キャンペーン期間に関するお知らせ",
      notice: "このアプリケーションは、お試しキャンペーンを実施しています。",
    },
    trial: {
      label: "試用版の期限がまもなく切れます",
      title: "試用期間",
      noticeSingular: "{0} は試用期間内です。試用版の期限はあと {1} 日で終了します。",
      notice: "{0} は試用期間内です。試用版の期限はあと {1} 日で終了します。",
    },
    subscriptionExpired: {
      label: "サブスクリプションの期限が切れました",
      title: "サブスクリプションの期限が切れました",
      notice: "{0} のサブスクリプションが終了しました。若干の猶予期間がありますが、その後はこの機能にアクセスできなくなります。",
    },
    trialExpired: {
      label: "試用版の期限が切れました",
      title: "試用期間の期限が切れました",
      notice: "{0} の試用期間が終了しました。若干の猶予期間がありますが、その後はこの機能にアクセスできなくなります。",
    },
    hpWarning: "{0}\nあなたはお客様の組織でHP Inc.の営業担当者となっています。注意してください。",
    role: {
      HP_Operation: "HPオペレーション",
      HP_Sales_and_Marketing: "HP顧客対応",
      SystemRoleGenesis_Admin: "PrintOSサービス管理者",
      SystemRoleGenesis_Support: "HP Inc.管理者",
      SystemRoleGenesis_R_AND_D: "Genesis研究開発",
      CE_Level_1: "CEレベル1",
      CE_Level_2: "CEレベル2",
      Application_Engineer: "アプリケーションエンジニア",
      Ramp_Up_Engineer: "ランプアップエンジニア",
      Support_Engineer: "サポートエンジニア",
      Remote_Support_Engineer: "HPサポートエンジニア",
      Specialist: "スペシャリスト",
      Certification_Centers: "認定センター",
      Supplies_and_Media_Personnel: "サプライ品およびメディア担当者",
      Supplies_and_Media_Admin: "サプライ品およびメディア管理者",
      HP_Service: "HPサービス",
      HP_Training: "HPトレーニング",
      Admin: "管理者",
      Pre_Press_Operator: "ユーザー",
      Press_Operator: "オペレーター",
      Dashboard: "ダッシュボード",
      Channel_Sales_and_Marketing: "チャネルセールスおよびマーケティング",
      Channel_Operation: "チャネルオペレーション",
      Channel_CE_Level_1: "チャネルCEレベル1",
      Channel_CE_Level_2: "チャネルCEレベル2",
      HP_Read_Only: "HP読み取りのみ",
      Reseller_Manager: "リセラーマネージャー",
      Business_Partner_Manager: "ビジネスパートナーマネージャー",
      Call_Center: "コールセンター",
      Field_Engineer: "フィールドエンジニア",
      ThreeD_Business_Manager: "3Dビジネスマネージャー",
      HPInPsp: "PSP内のHP",
      ChannelInPsp: "PSP内のチャネル",
      GenericAdmin: "管理者",
      GenericUser1: "ユーザーレベル1",
      GenericUser2: "ユーザーレベル2",
      Generic_Read_Only: "読み取り専用",
      ThreeD_Care_Center: "3Dケアセンター",
      ThreeD_Cost_Calculator: "3Dコスト",
      Composer_External: "限定アクセス - Composer",
      SIM_External: "Limited Access - サプライ品の在庫マネージャー",
      Multiple: "複数の役割"
    },
    inlineAlerts: {
      Http_429_Error: "高トラフィック",
      Http_429_Description: "現在、サービスに異常な負荷が生じています。一部の機能が一時的に利用できなくなっている可能性があります。ページを更新してもう一度試してください",
      Http_429_Action: "更新",
      NewSubscription: "新しいサブスクリプション - {0}",
      NewSubscriptionDescription: "組織に新しいサブスクリプションが存在します",
      NewSubscriptionAction: "詳細情報",
      SubscriptionExpired: "サブスクリプションの期限が切れました - {0}",
      SubscriptionExpiredDescription: "{0} にサブスクリプションの期限が切れました",
      SubscriptionExpiredAction: "サブスクリプションを表示",
      Subscription30DayWarning: "サブスクリプションの期限が切れます - {0}",
      Subscription30DayWarningDescription: "サブスクリプションは {0} 日後の {1} で期限が切れます。",
      Subscription30DayWarningAction: "サブスクリプションを表示",
      Subscription15DayWarning: "サブスクリプションの期限がまもなく切れます - {0}",
      Subscription15DayWarningDescription: "サブスクリプションは {0} 日後の {1} で期限が切れます。",
      Subscription15DayWarningAction: "サブスクリプションを表示",
      JoinOrgRequestAccepted: "組織への参加のリクエストが受諾されました",
      JoinOrgRequestAcceptedDescription: "<b>{0}</b> へのアクセスが許可されました",
      JoinOrgRequestSwitch: "組織を開く",
      JoinOrgRequestDenied: "組織への参加のリクエストが拒否されました",
      JoinOrgRequestDeniedDescription: "管理者によって <b>{0}</b> への参加リクエストが拒否されました",
      NonHPContext: "非HPコンテキストウィンドウを開く",
      NonHPContextDescription: "コンテキスト: {0}",
      CloseContext: "コンテキストを閉じる"
    },
    ui: {
      Confirm: "承認",
      Notify: "通知",
      OpenImage: "イメージファイルを開く",
      Dismiss: "解除",
      CheckingContext: "コンテキストを確認しています...",
      LoadingContext: "{0} を復元しています..."
    }
  }
};
